import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function NotFound() {
    return (
        <div
            className="min-h-screen flex items-center justify-center px-4"
            data-testid="not-found-page"
        >
            <div className="bg-white brut-border brut-shadow p-8 max-w-lg w-full text-center">
                <div className="font-display text-7xl sm:text-8xl leading-none">
                    <span className="bg-[#E8241A] text-white px-3 inline-block">
                        404
                    </span>
                </div>
                <h1 className="font-display text-2xl mt-6">Page not found.</h1>
                <p className="mt-2 text-sm opacity-80">
                    You might be lost. That’s OK.
                </p>
                <Link
                    to="/dashboard"
                    className="mt-6 inline-flex items-center gap-2 bg-black text-white font-display px-5 py-3 brut-border brut-shadow-sm brut-press"
                    data-testid="not-found-home-btn"
                >
                    <ArrowLeft size={16} strokeWidth={3} /> Back to Dashboard
                </Link>
            </div>
        </div>
    );
}
